"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.profile = exports.chat = exports.authn = exports.kb = exports.store = exports.solidLogicSingleton = void 0;

var debug = _interopRequireWildcard(require("./debug"));

var _solidAuthClient = _interopRequireDefault(require("solid-auth-client"));

var _solidLogic = require("solid-logic");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

// This module of solid-ui has a main quadstore for the app to use
//
var solidLogicSingleton = new _solidLogic.SolidLogic({
  fetch: _solidAuthClient["default"].fetch
}, _solidAuthClient["default"]); // Make this directly accessible as it is what you need most of the time

exports.solidLogicSingleton = solidLogicSingleton;
var store = solidLogicSingleton.store;
exports.store = store;
var kb = store; // Very commonly used synonym of store - Knowledge Base

exports.kb = kb;
var authn = solidLogicSingleton.authn;
exports.authn = authn;
var chat = solidLogicSingleton.chat; // export const language = solidLogicSingleton.language // Does not work

exports.chat = chat;
var profile = solidLogicSingleton.profile;
exports.profile = profile;
debug.log('Unique quadstore initialized.'); // ends
//# sourceMappingURL=logic.js.map